import type { Filter } from '../../../../../main/types/druidTypes';
import type { DruidNotFilter } from '../../../../../../../server/modules/druid';

export type NotType = 'not';

export default class NotFilter implements DruidNotFilter {
  dimension: void;

  field: Filter;

  fields: void;

  pattern: void;

  type: NotType;

  values: void;

  constructor(field: Filter) {
    this.type = 'not';
    this.field = field;
  }
}
